import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GlobalMapsService {
  private apiUrlGlobalMapCalcularRuta = environment.SUrlgApi + 'GoogleRoutes/computeroutes';

  constructor(private http: HttpClient) {}

  calcularRuta(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrlGlobalMapCalcularRuta, data).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  private handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(() => errorMessage);
  }

  private apiUrlGeocodeGoogle = environment.SUrlgApi + 'GlobalMap/geocodegoogle';

  geocodeGoogle(address: string): Observable<any> {
    let params = new HttpParams().set('Address', address);

    return this.http.get<any>(this.apiUrlGeocodeGoogle, { params }).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }
  
}
